const replaceAll = (str, mapObj) => str.replace(new RegExp(Object.keys(mapObj).join('|'), 'g'), (match) => mapObj[match]);
export default replaceAll;
//# sourceMappingURL=replaceAll.js.map